import * as React from 'react';

import { Settings } from "@mui/icons-material"
import { Button, Card, Chip, Divider, Grid, Paper, Typography } from "@mui/material"
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { NavLink, useNavigate } from "react-router"

import Autocomplete from '@mui/material/Autocomplete';
import TextareaAutosize from '@mui/material/TextareaAutosize';

import { obtenerFechaHoy } from "../../utils/fechas"

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { BiSolidTruck } from "react-icons/bi";
import { BiSolidTime } from "react-icons/bi";
import { BiSolidCheckShield } from "react-icons/bi";
import { resizeImageAuto } from '../../utils/resizeImgUtil';

import { styled } from '@mui/material/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { fromJSON } from 'postcss';

import imagenotfound from '../../image/Image-not-found.png'

import { useTablon } from '../../contexts/contextGeneral';


function ViewOrden(params) {
    const navigate = useNavigate()

    const { orden, setOrden } = useTablon()

    console.log(orden);


    const returnOrders = () => {
        navigate("/ordenes")
        setOrden(null)
    }

    const estatus = (x) => {
        const status = x
        if (status === null || status == 0) {
            return "noaplica"
        } else if (status == 1) {
            return "recibido"
        } else if (status == 2) {
            return "proceso"
        } else if (status == 3) {
            return "terminado"
        }
    }

    return (
        <>
            {orden !== null &&
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
                            <Typography variant='body1' color='warning' onClick={returnOrders}>Regresar</Typography>
                            <Chip sx={{ marginRight: '10px' }} label={estatus(orden.estatus)} size='small' color={estatus(orden.estatus)} />
                        </div>
                        <center>
                            <Typography variant='h6' color='primary'>Orden</Typography>
                            <Typography variant='h4' color='primary'><b>{orden.ot}</b></Typography>
                        </center>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Divider />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <Card sx={{ padding: "10px 20px" }}>
                            <Typography variant='h5' color='primary'>
                                <center><b>Cliente/Empresa</b></center>
                            </Typography>
                            <Typography variant='body1'><b>Nombre</b></Typography>
                            <Typography variant='body1'>{orden.compania.nombre}</Typography>
                        </Card>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <Card sx={{ padding: "10px 20px" }}>
                            <Typography variant='h5' color='primary'>
                                <center><b>Vehiculo</b></center>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12, md: 4 }} className="centerH">
                                    <div className="imagenVehiculo">
                                        <img src={orden.vehiculo.ruta ? "https://apiclimas.abdielaldana.com/" + orden.vehiculo.ruta : imagenotfound} alt="" width={"100%"} />
                                    </div>
                                </Grid>
                                <Grid size={{ xs: 12, md: 8 }}>
                                    <Typography variant="body1" noWrap>
                                        Placas: <b>{orden.vehiculo.placas}</b>
                                    </Typography>
                                    <Typography variant="body1" noWrap>
                                        Modelo: <b>{orden.vehiculo.marca} {orden.vehiculo.modelo}</b>
                                    </Typography>
                                    <Typography variant="body1" noWrap>
                                        Color: <b>{orden.vehiculo.color}</b>
                                    </Typography>
                                    <Typography variant="body1" noWrap>
                                        Kilometraje: <b>{orden.vehiculo.kilometraje} km</b>
                                    </Typography>
                                    <Typography variant="body1" noWrap>
                                        VIN: <b>{orden.vehiculo.vin}</b>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Card sx={{ padding: "10px 20px" }}>
                            <Typography variant='h5' color='primary'>
                                <center><b>Informacion</b></center>
                            </Typography>
                            {/* <Typography variant='body1'><b>Trabajo Realizado</b></Typography>
                            <Typography variant='body1'>{orden.orden.trabajo}</Typography> */}
                            <Divider sx={{ margin: "10px 0" }} />
                            <Typography variant='body1'><b>Observaciones</b></Typography>
                            <Typography variant='body1'>{orden.observacion == "" ? "No hay observaciones" : orden.observacion}</Typography>
                            <Divider sx={{ margin: "10px 0" }} />
                            <Typography variant='h5' color='primary' sx={{marginBottom: "10px"}}>
                                <center><b>Conceptos</b></center>
                            </Typography>

                            <Grid container spacing={2}>

                                {orden.conceptos.map((elem, i) => (

                                    <Grid size={{ xs: 12, md: 6 }} key={i}>
                                        <Paper
                                            elevation={2}
                                            sx={{
                                                p: 1.5,
                                                mb: 1,
                                                borderRadius: 2,
                                            }}
                                        >
                                            {/* Concepto */}
                                            <Typography variant="caption" color="text.secondary">
                                                Concepto {i + 1}
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                sx={{ fontWeight: 500, mb: 0.5 }}
                                            >
                                                <b>{elem.concepto}</b>
                                            </Typography>

                                            {/* Datos */}
                                            <Grid container>
                                                <Grid size={{ xs: 4 }}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Cant.
                                                    </Typography>
                                                    <Typography>{elem.cantidad}</Typography>
                                                </Grid>

                                                <Grid size={{ xs: 4 }}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        P. Unit
                                                    </Typography>
                                                    <Typography>${elem.precio_unitario}</Typography>
                                                </Grid>

                                                <Grid size={{ xs: 4 }}>
                                                    <Typography variant="caption" color="text.secondary">
                                                        Total
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: 600 }}>
                                                        ${elem.total}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                ))}

                                <Grid size={{ xs: 12 }}>
                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 1.5,
                                            mb: 1,
                                            borderRadius: 2,
                                        }}
                                    >
                                        <Typography variant="body1" color="text.secondary">
                                            Total
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            color='success'
                                            sx={{ fontWeight: 500, mb: 0.5 }}
                                        >
                                            $<b>{orden.precio}</b>MXN
                                        </Typography>
                                    </Paper>
                                </Grid>
                            </Grid>

                        </Card>
                    </Grid>
                </Grid>
            }
        </>

    )
}

export default ViewOrden